export default __webpack_public_path__ + "static/media/chatApp_1.e64a306c.jpeg";